import {
  AGREEMENTLINK,
  AGREEMENTLINK_ES,
  CALIFORNIA_COLLECTION_NOTICE_LINK,
  CALIFORNIA_COLLECTION_NOTICE_LINK_ES,
  COOKIE_POLICY_LINK,
  COOKIE_POLICY_LINK_ES,
  PARTNERSLINK,
  PARTNERSLINK_ES,
  PRIVACYLINK,
  PRIVACYLINK_ES,
  STATELICENSELINK,
  STATELICENSELINK_ES,
  TERMSOFUSELINK,
  TERMSOFUSELINK_ES,
} from "utilities/Constant";
import { isSpanishLanguage } from "utilities/getPreferredLanguage";
import { resolveUnauthenticatedDisplayLanguage } from "utilities/langPrefCookie";

export type FooterLegalLinks = {
  privacyPolicy: string;
  termsOfUse: string;
  electronicConsent: string;
  californiaCollectionNotice: string;
  cookiePolicy: string;
  partners: string;
  stateLicensing: string;
};

function resolveLocalizedUrl(spanishUrl: string, englishUrl: string, useSpanish: boolean): string {
  if (!useSpanish) {
    return englishUrl;
  }

  const trimmedSpanishUrl = spanishUrl.trim();
  return trimmedSpanishUrl || englishUrl;
}

/**
 * Same resolver as the public header toggle: Spanish langPref cookie, then
 * sessionStorage / Redux. Unauth toggle does not dispatch setPreferredLanguage.
 */
export function getFooterLegalLinks(preferredLanguage?: string | null): FooterLegalLinks {
  const resolvedLanguage = resolveUnauthenticatedDisplayLanguage(preferredLanguage);
  const useSpanish = isSpanishLanguage(resolvedLanguage);

  return {
    privacyPolicy: resolveLocalizedUrl(PRIVACYLINK_ES, PRIVACYLINK, useSpanish),
    termsOfUse: resolveLocalizedUrl(TERMSOFUSELINK_ES, TERMSOFUSELINK, useSpanish),
    electronicConsent: resolveLocalizedUrl(AGREEMENTLINK_ES, AGREEMENTLINK, useSpanish),
    californiaCollectionNotice: resolveLocalizedUrl(
      CALIFORNIA_COLLECTION_NOTICE_LINK_ES,
      CALIFORNIA_COLLECTION_NOTICE_LINK,
      useSpanish,
    ),
    cookiePolicy: resolveLocalizedUrl(COOKIE_POLICY_LINK_ES, COOKIE_POLICY_LINK, useSpanish),
    partners: resolveLocalizedUrl(PARTNERSLINK_ES, PARTNERSLINK, useSpanish),
    stateLicensing: resolveLocalizedUrl(STATELICENSELINK_ES, STATELICENSELINK, useSpanish),
  };
}
